import { of } from "rxjs";

export const NULL_OBSERVABLE = of(null);
